<template>

    <!-- Модальне вікно картки заявки -->
    <viewRequest 
      v-if="showRequestModal"
      @close="closeModal('request')" 
      :shortapplic="items"
      :closeOne="closeOnePerm"
      :client = 'this.client'
    >
    </viewRequest>

    <!-- Модальне вікно перегляду смс-повідомлення -->
    <viewSmsBox 
        v-if="showSmsModal"
        @close="showSmsModal = false"
        :obj="this.form"
    />

    <!-- Модальне вікно для відображення картки клієнта -->
    <viewbox 
        v-if="showModalUser == true" 
        @close="showModalUser = false;" 
        @call = "call"
        :objcard="this.objcard" 
        :companyId="this.searchComp.companyId"
    ></viewbox>

    <!-- 
      Модалка перегляду тікету
        @close - подія закриття перегляду тікету
        @prevOpen - дія на відкриття минулого тікету
        @nextOpen - дія на відкриття наступного тікету
        @getdata - дія отримання даних по тікетам
        @edit - дія на редагування тікету
        :obj - пропс передачі даних по тікету 
        :ifPrevopen - пропс на стрілочку вліво
        :ifNextopen - пропс на стрілочку вправо
    -->
    <viewboxTicket 
      v-if="showModalTicket" 
      @close="closeModal" 
      :obj="objcard" 
    ></viewboxTicket>

</template>

<script>
import viewRequest from '@/views/application/view/viewapplic' // картка заявки
import viewSmsBox from '@/components/sms/view' // картка перегляду смс
import viewbox from '@/views/accounts/allAccounts/viewnew/index.vue' // картка клієнта
import viewboxTicket from '@/views/newtickets/view/index.vue' // картка тікета
import { SuperAdmin, Tickets } from "@/API.js" 
import { storeS } from '@/store' // глобальний стор

let apiServe = new SuperAdmin();
let apiTickets = new Tickets();

export default{
    components: {
        viewRequest,
        viewSmsBox,
        viewbox,
        viewboxTicket
    },
    data(){
        return{
            form: '',
            showRequestModal: false,
            showSmsModal: false,
            showModalUser: false,
            objcard: '',
            searchComp: {
                companyTitle: '',
                number: '',
                companyId: '',
            },
            showModalTicket: false
        }
    },
    mounted() {

        // Слухання події sendSmsLog (відкриття вікна перегляду смс)
        this.eventBus.off('sendSmsLog')
        this.eventBus.on('sendSmsLog', (data) => {
            this.form = data.data
            this.showSmsModal = true
        })

        // Слухання події getCard (відкриття вікна карти клієнта)
        this.eventBus.off('openCardClient')
        this.eventBus.on('openCardClient', (data) => {
            this.getClient(data.phone, data.method)
        })

        // Слухання події getCard (відкриття вікна карти тікету)
        this.eventBus.off('openCardTicket')
        this.eventBus.on('openCardTicket', (data) => {
            this.getTicket(data.ticketId)
        })
    },
    methods: {
        getClient(num, method) {
            // Метод отримання клієнта за номером та методом пошуку

            // Додаємо можливість пошуку, якщо номер вказаний без 38
            var customNumber = num.toString();
            
            apiServe.getCardAcc(method, customNumber).then(result => {
                if(result.status == 'done'){
                    if(result.data.accountId != false && result.data.accountId != undefined){
                        this.objcard = result.data
                        this.$toast.success(this.$t('Account') + ` - ` + result.data.personalData.phone);
                        this.showModalUser = true;
                    } else {
                        this.objcard = result.data;
                        this.showModalUnUser = true
                    }
                } 
            })
        },
        getTicket(id){
            // Метод отримання тікету за номером

            apiTickets.getTicket(id).then(result => {
                if(result.status == 'done'){
                    this.objcard = result.data
                    this.showModalTicket = true;
                } else {
                    this.$toast.error(this.$t('error'));

                    var errorText = 'Помилка відкриття тікету'; 
                    var statusRequest = result.status;
                    var api = 'getTicket';
                    var fileRequest = 'src/views/newtickets/all.vue';
                    var params = id;
                    var response = result

                    // Викликаємо функцію для відправки повідомлення в телеграм
                    sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                    .then(response => console.log('Telegram API response:', response.data))
                    .catch(error => console.error('Telegram API error:', error));
                }
            })
        },
        closeModal(){
            this.showModalTicket = false
        },
    },
    computed: {
        perms() {
            /*
                Повертає дані прав доступу користувача з глобального стору.
            */
            return storeS.perms
        },
        user() {
            /*
                Повертає дані за користувача з глобального стору.
            */
            return storeS.userbase
        },
        checks(){
            /*
                Повертає дані з налаштувань юзера з глобального стору.
            */
            return storeS.checks
        },
    },

}

</script>